import Button from "../components/Button";
import styles from "./CategoryPage.module.css";

export default function CategoryPage({ title, description, image, chipBehindText = false }) {
  // `chipBehindText` adds a translucent dark plate behind the title +
  // description so light banners (Top Sellers 2026) keep legible white
  // type. The chip scales with the content via max-width + responsive
  // padding rather than a fixed size.
  return (
    <section className={styles.page}>
      <div className={styles.hero}>
        <img src={image} alt={title} />
        <div className={styles.overlay} />
        <div className={[styles.content, chipBehindText ? styles.contentChip : ""].join(" ")}>
          <h1>{title}</h1>
          <p>{description}</p>
          <Button label={`Shop ${title}`} />
        </div>
      </div>
    </section>
  );
}
